
        module.exports = __webpack_public_path__ + "assets/images/fod-fr-2023.1b58c1dc.svg";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 285,
            height: 61,
            type: "svg",
            bytes: 28350,

            toString: function() {
                return src;
            }
        };
    